import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PageLoaderService {

    public isLoading = false;

    constructor() { }

    public ShowPageLoader(): void {
        this.isLoading = true;
    }

    public HidePageLoader(): void {
        this.isLoading = false;
    }
}
